import { useState, type ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { createQueryClient } from '@/app/queryClient'

/** Provides a stable, per-app QueryClient and dev-only query devtools. */
export function QueryProvider({ children }: { children: ReactNode }) {
  // useState initialiser keeps a single client instance across re-renders.
  const [queryClient] = useState(createQueryClient)

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}
